import React from "react";

import { MarsbetLoading } from "@pages/casino/assets/icons";
import DefaultLoading from "@pages/casino/assets/images/loading.gif";
import ZenginsinLoading from "@pages/casino/assets/images/zenginsin-loading.png";

import {
	ExpandedLoadingContainer,
	GenericLoadingContainer,
	LoadingContainer,
	LoadingRing,
	LogoWrapper,
	MainLogo,
	PreloaderBg,
} from "./elements";

export const GannarLoader = () => (
	<ExpandedLoadingContainer>
		<div style={{ width: "130px", height: "135px" }}>
			<img src="/loading_up.png" />
		</div>
	</ExpandedLoadingContainer>
);

export const ZenginsinLoader = () => {
	return (
		<PreloaderBg>
			<LogoWrapper>
				<MainLogo
					src={ZenginsinLoading}
					alt="Zenginsin Logo"
				/>
				<LoadingRing />
			</LogoWrapper>
		</PreloaderBg>
	);
};

export const DefaultLoader = () => {
	return (
		<LoadingContainer>
			<img
				src={DefaultLoading}
				alt="Loading"
				width={250}
				height={250}
			/>
		</LoadingContainer>
	);
};

export const GenericLoader = () => {
	return (
		<GenericLoadingContainer
			className="loading-img"
			src="/generic_loading.gif"
			alt="Loading"
		/>
	);
};

export const MarsLoader = (props) => {
	return (
		<LoadingContainer>
			<MarsbetLoading {...props} />
		</LoadingContainer>
	);
};

const Loader = () => {
	if (window.ENABLE_MARS_LOADING) {
		return <MarsLoader />;
	}

	if (
		window.HAS_GANNAR_LOADING ||
		window.TENANT === "novero" ||
		window.TENANT === "luckykingbet" ||
		window.TENANT === "chainspin" ||
		window.TENANT === "rollblock" ||
		window.TENANT === "coinebet" ||
		window.TENANT === "flashsportscasino"
	) {
		return <GannarLoader />;
	}

	if (window.TENANT === "Zenginsin") {
		return <ZenginsinLoader />;
	}

	return (
		<img
			src="/loading_up.png"
			style={{ width: "130px", height: "135px" }}
		/>
	);
};

export default Loader;
